export function formatPropertyShare(value) {
  return value && value.share && value.total
    ? `${value.share.toString().replace('.', ',')}/${value.total}`
    : null
}
